import { render, staticRenderFns } from "./responsibilityManagementList.vue?vue&type=template&id=cfe3210c&"
import script from "./responsibilityManagementList.vue?vue&type=script&lang=js&"
export * from "./responsibilityManagementList.vue?vue&type=script&lang=js&"
import style0 from "./responsibilityManagementList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports